import JSEncrypt from 'jsencrypt';
import { getRsaPublicKey } from 'src/utils';

export const encryptPassword = (password: string): string => {
  const publicKey = getRsaPublicKey();
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(password) || '';
};
